import React from 'react';

export function PageStat({
  label,
  value,
  note
}: {
  label: string;
  value: string;
  note: string;
}) {
  return (
    <article className="metricCard">
      <div className="metricHead">
        <div>
          <div className="metricLabel">{label}</div>
          <div className="metricValue">{value}</div>
        </div>
      </div>
      <div className="metricMeta">{note}</div>
    </article>
  );
}
